export const TestIdsComponents = {
  PageTitle: 'page-title',
  LoadingIndicator: 'loading-indicator',
  BrandingLogo: 'branding-logo',
  LastKnownLocationText: 'last-known-location-text',
  LastKnownLocationMap: 'last-known-location-map',
  LastKnownLocationCard: 'last-known-location-card'
}
